import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const CircleSelected32: FC<IconV2Props> = ({
  icon,
  chroma,
  name,
  className,
  ...otherProps
}) => {
  return (
    <svg
      className={
        chroma === 'dark'
          ? cn(s.svgDark32, `svg-icon--${icon}`, className)
          : cn(s.svgLight32, `svg-icon--${icon}`, className)
      }
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={chroma === 'dark' ? `${icon}-32-solid` : `${icon}-32`}
      {...otherProps}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(4.000000, 4.000000)">
          <circle
            className={chroma === 'dark' ? s.darkFill : s.lightFill}
            cx="12"
            cy="12"
            r="12"
            name={name}
          />
          <polygon
            className={chroma === 'dark' ? s.lightFill : s.darkFill}
            points="7.20710678 11.7928932 5.79289322 13.2071068 10 17.4142136 18.7071068 8.70710678 17.2928932 7.29289322 10 14.5857864"
            name={name}
          />
        </g>
      </g>
    </svg>
  );
};

export default CircleSelected32;
